// extracted by css-extract-rspack-plugin
export default {"reportPage":"bgA5_of5PP4dFnhI__reportPage___"};